import types from '../actiontypes'

export const CloseDrawer = (key) => {
  return {
    type: types.Drawer.Hide,
    payload: {
      key
    }
  }
}

export const CloseDrawerDispatch = (dispatch) => {
  return (key) => {
    dispatch(CloseDrawer(key))
  }
}

export const OpenDrawer = (component, messageBusKey, props, drawerSize = 'Half') => {
  return {
    type: types.Drawer.Show,
    payload: {
      drawerSize,
      component,
      props,
      messageBusKey
    }
  }
}

export const OpenDrawerDispatch = (dispatch) => {
  return (component, messageBusKey, props, drawerSize) => {
    dispatch(OpenDrawer(component, messageBusKey, props, drawerSize))
  }
}
